import { Button, Menu, MenuItem, Typography } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Popover from "@material-ui/core/Popover";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import RemoveIcon from "@material-ui/icons/Remove";
import { makeStyles } from "@material-ui/styles";
import ContentTitle from "components/common/ContentTitle";
import EditButton from "components/common/EditButton";
import InfoIconButton from "components/common/InfoIconButton";
import {
  cancelServiceId,
  HealthStatus,
  statusReportServiceId,
  STATUS_PROCESS
} from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import { CANCEL_STEP, STATUS_REPORT_STEP } from "libs/constant/VisaStep";
import useModalLoading from "libs/hooks/useModalLoading";
import { getRouterChangeSmartByConditionType } from "libs/utils/changeSmart";
import { formatDate } from "libs/utils/format";
import { get } from "lodash-es";
import mime from "mime";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { selectIsAdmin } from "redux/modules/authSlice";
import { setStep as cancelSetStep } from "redux/modules/cancelVisaSlice";
import { setStep } from "redux/modules/statusReportSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  currentDocumentSlice,
  getListSmartForm,
  getSmartForm,
  selectCurrentDocument,
  selectCurrentSmartForm,
  selectListSmartForm,
  setSmartServiceId
} from "redux/modules/visaForm";
import AllDocumentsService from "services/AllDocumentsService";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#f1f3f9",
    color: "#172b4d",
    fontSize: 16,
    padding: "0px 16px",
  },
  body: {
    fontSize: 16,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
    paddingBottom: 124,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  table: {
    minWidth: 700,
    "& .MuiTableCell-root": {
      borderLeft: "0px solid rgba(224, 224, 224, 1)",
      borderRight: "0px solid rgba(224, 224, 224, 1)",
      height: 40,
    },
  },
  tableTitle: {
    color: "#8898aa",
    marginLeft: 16,
  },
  badge: {
    display: "flex",
    width: 12,
    height: 12,
    borderRadius: 12,
    backgroundColor: "#feb969",
    marginRight: 12,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  badgeSuccess: {
    display: "flex",
    width: 12,
    height: 12,
    borderRadius: 12,
    backgroundColor: "#2DCE98",
    marginRight: 12,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
  listRoot: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  popover2: {
    // pointerEvents: 'none',
  },
  popoverContent2: {
    // pointerEvents: 'auto',
  },
  iconPop: {
    color: "white",
    fontWeight: "bold",
    marginRight: "10px",
    borderRadius: "50%",
    verticalAlign: "middle",
    width: "25px",
    height: "25px",
  },
}));

export default function DocumentList() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { hideLoading, showLoading } = useModalLoading();
  const listSmartFormState = useSelector(selectListSmartForm);
  const currentDocumentState = useSelector(selectCurrentDocument);
  const smartForm = useSelector(selectCurrentSmartForm);
  const isAdmin = useSelector(selectIsAdmin);

  const typeDocSmartFromID = get(smartForm, "typeDocSmartFromID", "");
  const statausID = get(smartForm, "statausID", "");
  const healthStatus = get(smartForm, "healthStatus", "");

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const detail = get(smartForm, "detail", []).reduce(smartNameById, {});
  const ConditionType = get(detail, "ConditionType.value", "");

  const [anchorEl, setAnchorEl] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const [openPrintIndex, setOpenPrintIndex] = useState(null);
  const [anchorElPrint, setAnchorElPrint] = useState(null);
  const openPrint = Boolean(anchorElPrint);
  const [openedPopoverId, setOpenedPopoverId] = useState(null);
  const [anchorElDetail, setAnchorElDetail] = useState(null);

  const handleOpenPrint = (index) => (event) => {
    setOpenPrintIndex(index)
    setAnchorElPrint(event.currentTarget);
  };
  const handleClosePrint = () => {
    setOpenPrintIndex(null)
    setAnchorElPrint(null);
  };
  const handlePopoverOpen = (index) => (event) => {
    setOpenIndex(index);
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setOpenIndex(null);
    setAnchorEl(null);
  };

  const open = openIndex;

  const openDetail = Boolean(anchorElDetail);

  useEffect(() => {
    dispatch(getListSmartForm());
  }, [dispatch]);

  useEffect(() => {
    if (currentDocumentState.isSuccess || currentDocumentState.isFailure) {
      hideLoading();
      if (currentDocumentState.isSuccess) {
        dispatch(currentDocumentSlice.actions.clearAsyncState());
        // TODO wait for check 5 smart
        if (statausID === STATUS_PROCESS.RequestAddDoc) {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        } else if (typeDocSmartFromID === "E") {
          dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
        } else if (typeDocSmartFromID === "C") {
          dispatch(
            setSmartFormStep(
              getRouterChangeSmartByConditionType(ConditionType)[1]
            )
          );
        } else if (
          statausID === STATUS_PROCESS.ReviewingHealthInsurance &&
          /**
           *  admin -> Goto health insurance always
           *  user  -> Goto health insurance only healthStatus = D and RD
           */
          (isAdmin ||
            healthStatus === HealthStatus.Draft ||
            healthStatus === HealthStatus.RequestDocument)
        ) {
          dispatch(setSmartFormStep(SMART_T_STEP.HEALTH_INSUANCE));
        } else {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
        }
      }
    }
  }, [
    currentDocumentState,
    dispatch,
    hideLoading,
    typeDocSmartFromID,
    ConditionType,
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Reject":
        return "#ED1C24";
      case "Completed":
        return "#2DCE98";
      case "Draft":
        return "#B0B6BA";
      case "Pending":
      default:
        return "#feb969";
    }
  };

  return (
    <div className={classes.root}>
      <ContentTitle
        title="Check Status"
        subTitle=""
        hideLine
      />
      <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell>
                <Typography variant="h6" className={classes.tableTitle}>
                  DATE
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="h6" className={classes.tableTitle}>
                  DOC No.
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="h6" className={classes.tableTitle}>
                  VISA TYPE
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="h6" className={classes.tableTitle}>
                  DOC TYPE
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="h6" className={classes.tableTitle}>
                  STAFF NAME
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="h6" className={classes.tableTitle}>
                  STATUS
                </Typography>
              </StyledTableCell>
              <StyledTableCell align="center">
                <Typography variant="h6" className={classes.tableTitle}>
                  ACTION
                </Typography>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listSmartFormState.data.map((data, index) => (
              <TableRow key={data.draftId}>
                <StyledTableCell>
                  <Typography>
                    {formatDate(data.smartDate, "DD MMM YYYY HH:mm")}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography>{data.smartNo || "-"}</Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography>{data.smartserviceName || "-"}</Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography>{data.typeDocSmartFromName || "-"}</Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography>{data.staffname || "-"}</Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    className={classes.flexRow}
                    aria-owns={open ? `mouse-over-popover-${index}` : undefined}
                    aria-haspopup="true"
                  // onMouseEnter={handlePopoverOpen(index)}
                  // onMouseLeave={handlePopoverClose}
                  >
                    {data.statusProcessId === STATUS_PROCESS.Complete && (
                      <div
                        className={classes.badgeSuccess}
                        style={{
                          backgroundColor: "#2DCE98",
                        }}
                      />
                    )}
                    {data.statusProcessId !== STATUS_PROCESS.Complete &&
                      data.statusProcessId !== STATUS_PROCESS.Rejected &&
                      data.statusProcessId !== STATUS_PROCESS.FinalRejected && (
                        <div
                          className={classes.badgeSuccess}
                          style={{
                            backgroundColor: "#FEB969",
                          }}
                        />
                      )}
                    {data.statusProcessId === STATUS_PROCESS.Rejected ||
                      (data.statusProcessId ===
                        STATUS_PROCESS.FinalRejected && (
                          <div
                            className={classes.badgeSuccess}
                            style={{
                              backgroundColor: "#F53C56",
                            }}
                          />
                        ))}

                    {/* <Typography>{data.statusDocName}</Typography> */}
                    <Typography>
                      {data.statusProcessId ===
                        STATUS_PROCESS.ReviewingHealthInsurance &&
                        data.healthStatus === "RD"
                        ? data.statusDocName + " (Request document)" // healthStatus
                        : data.statusProcessName}
                    </Typography>
                  </div>
                  <Popover
                    id={`mouse-over-popover-${index}`}
                    className={classes.popover}
                    classes={{
                      paper: classes.paper,
                    }}
                    elevation={2}
                    open={open === index}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    onClose={handlePopoverClose}
                    disableRestoreFocus
                  >
                    <div className={classes.listRoot}>
                      <List component="nav">
                        <ListItem button>
                          <ListItemText
                            primary="Organization"
                            style={{ textAlign: "center" }}
                          />
                        </ListItem>
                      </List>

                      <Divider />
                      <List component="nav">
                        {data.configApprveSmartFrom.map((ap) => (
                          <ListItem button key={ap.departmentId}>
                            <ListItemIcon>
                              {(ap.statusProcessId ===
                                STATUS_PROCESS.Complete ||
                                ap.statusProcessId ===
                                STATUS_PROCESS.Processing ||
                                ap.statusProcessId ===
                                STATUS_PROCESS.Approved) && (
                                  // <CheckCircleIcon style={{ color: "#2DCE98" }} />
                                  <Fragment>
                                    <div
                                      className={classes.iconPop}
                                      style={{ backgroundColor: "#2DCE98" }}
                                    >
                                      <CheckIcon></CheckIcon>
                                    </div>
                                  </Fragment>
                                )}

                              {(ap.statusProcessId === STATUS_PROCESS.Pending ||
                                ap.statusProcessId ===
                                STATUS_PROCESS.UploadAddDoc) && (
                                  // <RemoveIcon style={{ color: "#FEB969", bac }} />
                                  <Fragment>
                                    <div
                                      className={classes.iconPop}
                                      style={{ backgroundColor: "#FEB969" }}
                                    >
                                      <RemoveIcon></RemoveIcon>
                                    </div>
                                  </Fragment>
                                )}

                              {(ap.statusProcessId ===
                                STATUS_PROCESS.Rejected ||
                                ap.statusProcessId ===
                                STATUS_PROCESS.FinalRejected) && (
                                  <Fragment>
                                    <div
                                      className={classes.iconPop}
                                      style={{ backgroundColor: "#F53C56" }}
                                    >
                                      <CloseIcon></CloseIcon>
                                    </div>
                                  </Fragment>
                                )}

                              {/* {ap.statusProcessName === "Completed" ? (
                                <CheckCircleIcon style={{ color: "#2DCE98" }} />
                              ) : (
                                <RemoveCircleIcon
                                  style={{ color: "#FEB969", marginLeft: 0 }}
                                />
                              )} */}
                            </ListItemIcon>
                            <ListItemText primary={ap.departmentName} />
                          </ListItem>
                        ))}
                      </List>
                    </div>
                  </Popover>
                </StyledTableCell>
                <StyledTableCell align="right">
                  <div
                    className={classes.flexRow}
                    style={{ justifyContent: "flex-end" }}
                  >
                    {
                      ((data?.typeDocSmartFromID === 'R') &&
                        (
                          data?.statusProcessId === "C" ||
                          data?.statusProcessId === "FAP" ||
                          data?.statusProcessId === "AP"
                        )) ? (
                        <>
                          <Button
                            id={`basic-buttonPrint-${index}`}
                            aria-controls={
                              openPrint ? `basic-menuPrint-${index}` : undefined
                            }
                            aria-haspopup="true"
                            aria-expanded={openPrint ? "true" : undefined}
                            onClick={handleOpenPrint(index)}
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: 5 }}
                          >
                            Print
                          </Button>
                          <Menu
                            id={`basic-menuPrint-${index}`}
                            anchorEl={anchorElPrint}
                            open={openPrintIndex === index}
                            onClose={handleClosePrint}
                            MenuListProps={{
                              "aria-labelledby": `basic-buttonPrint-${index}`,
                            }}
                          >
                            <MenuItem
                              key={index}
                              onClick={async () => {
                                const filename = data.draftId + ".pdf";
                                const blob =
                                  await AllDocumentsService.downloadDocDetail(
                                    data.draftId
                                  );
                                const blobFile = new File([blob], filename, {
                                  type: mime.getType(".pdf"),
                                });

                                window.open(
                                  URL.createObjectURL(blobFile),
                                  "_blank"
                                );

                                setAnchorElPrint(null);
                              }}
                            >
                              Notification Letter for Qualifications Endorsement
                            </MenuItem>
                            {!data?.visaissurance?.overseas && (
                              <MenuItem
                                key={index}
                                onClick={async () => {
                                  const filename = data.draftId + ".pdf";
                                  const blob =
                                    await AllDocumentsService.downloadLongResidentVisaTH(
                                      data.draftId
                                    );
                                  const blobFile = new File([blob], filename, {
                                    type: mime.getType(".pdf"),
                                  });

                                  window.open(
                                    URL.createObjectURL(blobFile),
                                    "_blank"
                                  );

                                  setAnchorElPrint(null);
                                }}
                              >
                                Report to Immigration Bureau
                              </MenuItem>
                            )}
                            {/* <MenuItem
                            key={index}
                            onClick={async () => {
                              const filename = data.draftId + ".pdf";
                              const blob =
                                await AllDocumentsService.downloadLongResidentVisaTH(
                                  data.draftId
                                );
                              const blobFile = new File([blob], filename, {
                                type: mime.getType(".pdf"),
                              });

                              window.open(
                                URL.createObjectURL(blobFile),
                                "_blank"
                              );

                              setAnchorElPrint(null);
                            }}
                          >
                            Report to Immigration Bureau
                          </MenuItem>
                          {dataDetail?.workpermit?.isRequest && (
                            <MenuItem
                              key={index}
                              onClick={async () => {
                                const filename = data.draftId + ".pdf";
                                const blob =
                                  await AllDocumentsService.downloadNotificationPassLongVisaDWPTH(
                                    data.draftId
                                  );
                                const blobFile = new File([blob], filename, {
                                  type: mime.getType(".pdf"),
                                });

                                window.open(
                                  URL.createObjectURL(blobFile),
                                  "_blank"
                                );

                                setAnchorElPrint(null);
                              }}
                            >
                              Report to Department of Employment
                            </MenuItem>
                          )} */}
                          </Menu>
                        </>
                      ) : null}
                    <EditButton
                      title="View"
                      onClick={() => {
                        showLoading();

                        if (data.smartserviceId === cancelServiceId) {
                          dispatch(cancelSetStep(CANCEL_STEP.CANCEL_A));
                          history.push(
                            `/cancel-visa/${data.personalId}?draftId=${data.draftId}`
                          );
                          hideLoading();
                        } else if (
                          data.smartserviceId === statusReportServiceId
                        ) {
                          history.push(
                            `/status-report/${data.personalId}?draftId=${data.draftId}`
                          );
                          dispatch(
                            setStep(STATUS_REPORT_STEP.STATUS_REPORT_STEP_A)
                          );
                          hideLoading();
                        } else {
                          dispatch(setSmartServiceId(data.smartserviceId));
                          dispatch(
                            getSmartForm({
                              personalId: data.personalId,
                              smartserviceId: data.smartserviceId,
                              draftId: data.draftId,
                            })
                          );
                        }
                      }}
                    />
                    <InfoIconButton
                      aria-describedby="mouse-over-detial-popover"
                      onClick={(event) => {
                        const hasSomeActionListMenu =
                          data?.statusDocId === STATUS_PROCESS.Complete ||
                          data?.statusDocId === STATUS_PROCESS.FinalApproved ||
                          data?.statusProcessId === STATUS_PROCESS.Draft ||
                          data?.statusProcessId === STATUS_PROCESS.Pending ||
                          data?.statusProcessId === STATUS_PROCESS.Processing ||
                          data?.statusProcessId ===
                          STATUS_PROCESS.FinalRejected ||
                          data?.statusProcessId === STATUS_PROCESS.Rejected ||
                          data?.statusProcessId ===
                          STATUS_PROCESS.RequestAddDoc ||
                          data?.statusProcessId === STATUS_PROCESS.UploadAddDoc;
                        if (hasSomeActionListMenu) {
                          setOpenedPopoverId(data.draftId);
                          setAnchorElDetail(event.currentTarget);
                        }
                      }}
                    />
                    <Popover
                      className={classes.popover2}
                      classes={{
                        paper: classes.popoverContent2,
                      }}
                      open={openDetail && openedPopoverId === data.draftId}
                      anchorEl={anchorElDetail}
                      onClose={() => {
                        setOpenedPopoverId(null);
                        setAnchorElDetail(null);
                      }}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                    >
                      {/* <Typography className={classes.typography}
                        onClick={(e) => {
                        }}>The content of the Popover.</Typography> */}

                      <List component="nav">
                        {/* {data.statusDocId === STATUS_PROCESS.Complete ||
                          (data.statusDocId ===
                            STATUS_PROCESS.FinalApproved && (
                            <ListItem button>
                              <ListItemText
                                primary="Download"
                                onClick={async () => {
                                  if (
                                    data.statusDocId ===
                                      STATUS_PROCESS.Complete ||
                                    data.statusDocId ===
                                      STATUS_PROCESS.FinalApproved
                                  ) {
                                    const draftId = data.draftId;
                                    const filename = draftId + ".pdf";
                                    const blob =
                                      await AllDocumentsService.downloadDocDetail(
                                        draftId
                                      );
                                    const blobFile = new File(
                                      [blob],
                                      filename,
                                      {
                                        type: mime.getType(".pdf"),
                                      }
                                    );

                                    window.open(
                                      URL.createObjectURL(blobFile),
                                      "_blank"
                                    );

                                    setOpenedPopoverId(null);
                                    setAnchorElDetail(null);
                                  }
                                }}
                              />
                            </ListItem>
                          ))} */}

                        {data.statusDocId === STATUS_PROCESS.Rejected ||
                          (data.statusDocId ===
                            STATUS_PROCESS.FinalRejected && (
                              <ListItem button>
                                <ListItemText
                                  primary="Download"
                                  onClick={async () => {
                                    if (
                                      data.statusDocId ===
                                      STATUS_PROCESS.Rejected ||
                                      data.statusDocId ===
                                      STATUS_PROCESS.FinalRejected
                                    ) {
                                      const draftId = data.draftId;
                                      const filename = draftId + ".pdf";
                                      const blob =
                                        await AllDocumentsService.downloadDocDetail(
                                          draftId
                                        );
                                      const blobFile = new File(
                                        [blob],
                                        filename,
                                        {
                                          type: mime.getType(".pdf"),
                                        }
                                      );

                                      window.open(
                                        URL.createObjectURL(blobFile),
                                        "_blank"
                                      );

                                      setOpenedPopoverId(null);
                                      setAnchorElDetail(null);
                                    }
                                  }}
                                />
                              </ListItem>
                            ))}

                        {(data.statusDocId === STATUS_PROCESS.Complete ||
                          data.statusDocId === STATUS_PROCESS.FinalApproved) &&
                          data.typeDocSmartFromID === "T" && (
                            <ListItem button>
                              <ListItemText
                                primary="Download"
                                onClick={async () => {
                                  if (
                                    data.statusDocId ===
                                    STATUS_PROCESS.Complete ||
                                    data.statusDocId ===
                                    STATUS_PROCESS.FinalApproved
                                  ) {
                                    const draftId = data.draftId;
                                    const filename = draftId + ".pdf";
                                    const blob =
                                      await AllDocumentsService.downloadTerminate(
                                        draftId
                                      );
                                    const blobFile = new File(
                                      [blob],
                                      filename,
                                      {
                                        type: mime.getType(".pdf"),
                                      }
                                    );

                                    window.open(
                                      URL.createObjectURL(blobFile),
                                      "_blank"
                                    );

                                    setOpenedPopoverId(null);
                                    setAnchorElDetail(null);
                                  }
                                }}
                              />
                            </ListItem>
                          )}

                        {(data.statusDocId === STATUS_PROCESS.Complete ||
                          data.statusDocId === STATUS_PROCESS.FinalApproved) &&
                          data.typeDocSmartFromID === "C" && (
                            <ListItem button>
                              <ListItemText
                                primary="Download"
                                onClick={async () => {
                                  if (
                                    data.statusDocId ===
                                    STATUS_PROCESS.Complete ||
                                    data.statusDocId ===
                                    STATUS_PROCESS.FinalApproved
                                  ) {
                                    const draftId = data.draftId;
                                    const filename = draftId + ".pdf";
                                    const blob =
                                      await AllDocumentsService.downloadChange(
                                        draftId
                                      );
                                    const blobFile = new File(
                                      [blob],
                                      filename,
                                      {
                                        type: mime.getType(".pdf"),
                                      }
                                    );

                                    window.open(
                                      URL.createObjectURL(blobFile),
                                      "_blank"
                                    );

                                    setOpenedPopoverId(null);
                                    setAnchorElDetail(null);
                                  }
                                }}
                              />
                            </ListItem>
                          )}

                        {(data?.statusProcessId === "D" ||
                          data?.statusProcessId === "P") && (
                            <ListItem button>
                              <ListItemText
                                primary="Cancel"
                                onClick={async () => {
                                  if (
                                    !window.confirm(
                                      "Do you want to cancel document?"
                                    )
                                  ) {
                                    return;
                                  }

                                  const res =
                                    await AllDocumentsService.cancelSmartForm({
                                      draftId: data?.draftId,
                                    });

                                  if (res.status) {
                                    dispatch(getListSmartForm());
                                  }
                                }}
                              />
                            </ListItem>
                          )}
                        {data?.statusProcessId === "FA" && (
                          <ListItem button>
                            <ListItemText
                              primary="Preapprove"
                              onClick={async () => {
                                history.push(`/Preapprove/${data.draftId}`);
                              }}
                            />
                          </ListItem>
                        )}
                      </List>
                    </Popover>
                    {/* 
                    <div>
                      <Button aria-describedby="mouse-over-detial-popover" variant="contained" color="primary" onClick={(event) => {
                        setAnchorElDetail(event.currentTarget);
                      }}>
                        Open Popover
                      </Button>

                    </div> */}
                  </div>
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
